module.exports = __webpack_public_path__ + "static/media/cashback_wallet_modal_asset_02.90cc62e8.svg";